import { render } from "./VoucherRecommendedForYou.vue?vue&type=template&id=b382f962&scoped=true"
import script from "./VoucherRecommendedForYou.vue?vue&type=script&lang=js"
export * from "./VoucherRecommendedForYou.vue?vue&type=script&lang=js"

import "./VoucherRecommendedForYou.vue?vue&type=style&index=0&id=b382f962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b382f962"]])

export default __exports__